import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { SnippetsResponse } from '../../../../shared/snippets';

//  Actual function to fetch snippets
function getSnippets(locator: string) {
  return get<SnippetsResponse>(`/api/revisions/${nuc(locator)}/snippets`);
}

export const getSnippetsQueryKey = (locator: string): QueryKey => ['revisions', locator, 'snippets'];

/**
 * useSnippets is a hook that fetches and returns the snippets for the given locator.
 */
export default function useSnippets(locator: string) {
  return useQuery<SnippetsResponse>({
    queryKey: getSnippetsQueryKey(locator),
    queryFn: () => getSnippets(locator),
  });
}
